module.exports = __webpack_public_path__ + "img/official-4.04292aab.png";